<template>
    <modal id="banner-modal"
           v-model="showModal"
           :title="generateModalTitle('banner')"
           @submit="submitData"
           :loading="loading"
           :preloader="preloader"
    >
        <app-form-group
                :label="$t('url')"
                v-model="formData.page_url"
                :placeholder="$placeholder('url')"
                :errorMessage="$errorMessage(errors, 'page_url')"
        />
        <div class="form-group">
            <label for="image">{{ $t('image') }}</label>
            <app-input
                    :generate-file-url="false"
                    :label="$t('choose_file')"
                    type="custom-file-upload"
                    v-model="image"
                    id="image"
                    :errorMessage="$errorMessage(errors, 'image')"
            />
        </div>
    </modal>
</template>

<script>
    import ModalMixin from "../../../../Mixins/ModalMixin";
    import FormHelperMixin from "../../../../Mixins/FormHelperMixin";
    import {formDataAssigner} from "../../../../Helpers/Helpers";

    export default {
        name: "BannerCreateEdit",
        mixins: [ModalMixin, FormHelperMixin],
        data() {
            return {
                image: {}
            }
        },
        methods: {
            submitData() {
                this.fieldStatus.isSubmit = true;
                this.loading = true;
                this.message = '';
                this.errors = {};
                const formData = formDataAssigner(new FormData, this.formData);
                if (this.image && this.image instanceof File) {
                    formData.append('image', this.image);
                }
                if (this.selectedUrl) {
                    formData.append('_method', 'patch');
                }
                this.submitFromFixin(
                    'post',
                    this.selectedUrl ? this.selectedUrl : this.apiUrl.BANNERS,
                    formData
                );
            },
            afterSuccessFromGetEditData({data}) {
                this.formData = data;
                this.preloader = false;
                this.image = data.path;
                if (!Boolean(data.page_url)) {
                    delete this.formData.page_url;
                }
            },
            afterSuccess({data}) {
                this.formData = {};
                $('#banner-modal').modal('hide');
                this.$emit('input', false);
                this.toastAndReload(data.message, 'banners-table');
            },
        }
    }
</script>

<style scoped>

</style>